import { useTranslation } from 'react-i18next';
import BenefitBucksWideImg from '../../../../../common/assets/images/marketing/mkt-benefit-bucks.webp';
import useBreakpoints from '../../../../../common/hooks/useBreakpoints';
import Icons from '../../../../../common/widgets/Icons';
import { resources } from '../../../resources/resources';

export default function BenefitBucks() {
  const { t: translate } = useTranslation();
  const { isMobile } = useBreakpoints();

  return (
    <div className="mkt-card benefit-bucks-card">
      <div className="mkt-card-img">
        <img
          src={BenefitBucksWideImg}
          alt="{translate(resources.marketingCards.benefitBucksWide.title)}"
        />
      </div>
      <div className="mkt-card-copy">
        <h3 className="mkt-card-title">
          {translate(resources.marketingCards.benefitBucksWide.title)}
        </h3>
        {!isMobile && (
          <div className="mkt-card-text">
            <ul>
              <li>
                {translate(resources.marketingCards.benefitBucksWide.text1)}
              </li>
              <li>
                {translate(resources.marketingCards.benefitBucksWide.text2)}
              </li>
              <li>
                {translate(resources.marketingCards.benefitBucksWide.text3)}
              </li>
            </ul>
          </div>
        )}
        <div className="mkt-card-action">
          <a
            onClick={() => {
              const descriptionElement = document.getElementById(
                'category-description',
              );
              descriptionElement?.scrollIntoView();
            }}
            className="btn-link"
          >
            <span className="btn-icon">
              <Icons.ArrowButton />
            </span>
            <span className="btn-text">
              {translate(resources.marketingCards.benefitBucksWide.action)}
            </span>
          </a>
        </div>
      </div>
    </div>
  );
}
